// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "rescript-classnames/src/Cn.bs.js";
import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Util from "../../common/util.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Theme from "../../css/Theme.bs.js";
import * as React from "react";
import * as Js_null from "@rescript/std/lib/es6/js_null.js";
import * as Segment from "../../bindings/Segment.bs.js";
import * as AuthUtils from "../../auth/user/AuthUtils.bs.js";
import * as Js_promise from "@rescript/std/lib/es6/js_promise.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as FormHelpers from "../../utils/FormHelpers.bs.js";
import * as FormReducer from "../../utils/FormReducer.bs.js";
import * as UserContext from "../../auth/user/UserContext.bs.js";
import * as Router from "next/router";
import * as $$Notification from "./Notification.bs.js";
import * as ReactHookForm from "../../bindings/ReactHookForm.bs.js";
import * as ReactHookForm$1 from "react-hook-form";
import * as SignUpStepStyles from "../pages/register/steps/SignUpStepStyles.bs.js";
import * as LayoutDataContext from "../../utils/LayoutDataContext.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as PrezzeePublicClient from "../../api/PrezzeePublicClient.bs.js";
import * as PrezzeeSecureClient from "../../api/PrezzeeSecureClient.bs.js";
import * as Button$PrezzeeRibbon from "@prezzee/ribbon/src/components/personal/Button/Button.bs.js";
import * as RichText$PrezzeeRibbon from "@prezzee/ribbon/src/components/personal/RichText/RichText.bs.js";
import FormInputPin from "@prezzee/ribbon-ui/lib/components/FormInputPin";

var nestedInput = Curry._1(Css.style, {
      hd: Css.important(Css.display("flex")),
      tl: {
        hd: Css.selector("input", {
              hd: Css.lineHeight(Css.px(50)),
              tl: {
                hd: Css.color(Theme.Color.charcoal),
                tl: {
                  hd: Css.borderRadius(Css.px(6)),
                  tl: {
                    hd: Css.width(Css.pct(100)),
                    tl: {
                      hd: Css.height(Css.pct(100)),
                      tl: {
                        hd: Css.boxSizing("borderBox"),
                        tl: {
                          hd: Css.fontSize(Css.px(32)),
                          tl: {
                            hd: Css.margin(Css.px(4)),
                            tl: {
                              hd: Css.borderWidth(Css.px(2)),
                              tl: {
                                hd: Css.borderStyle("solid"),
                                tl: {
                                  hd: Css.borderColor(Theme.Color.gray300),
                                  tl: {
                                    hd: Css.paddingBottom(Css.px(4)),
                                    tl: {
                                      hd: Css.textAlign("center"),
                                      tl: {
                                        hd: Css.flex({
                                              NAME: "num",
                                              VAL: 1
                                            }),
                                        tl: {
                                          hd: Css.outline(Css.px(0), "solid", "transparent"),
                                          tl: {
                                            hd: Css.focus({
                                                  hd: Css.borderColor(Theme.Color.blue400),
                                                  tl: /* [] */0
                                                }),
                                            tl: /* [] */0
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }),
        tl: /* [] */0
      }
    });

var codeContainer = Curry._1(Css.style, {
      hd: Css.display("flex"),
      tl: {
        hd: Css.flexDirection("column"),
        tl: /* [] */0
      }
    });

var title = Curry._1(Css.style, {
      hd: Css.fontSize(Css.rem(1.75)),
      tl: {
        hd: Css.fontWeight({
              NAME: "num",
              VAL: 700
            }),
        tl: {
          hd: Css.marginBottom(Css.rem(2.5)),
          tl: {
            hd: Css.media("(max-width: 480px)", {
                  hd: Css.fontSize(Css.rem(1.25)),
                  tl: /* [] */0
                }),
            tl: /* [] */0
          }
        }
      }
    });

var btn = Curry._1(Css.style, {
      hd: Css.color(Theme.Color.blue400),
      tl: /* [] */0
    });

var Styles = {
  nestedInput: nestedInput,
  codeContainer: codeContainer,
  title: title,
  btn: btn
};

function getSignupType(signupTypeValue) {
  switch (signupTypeValue) {
    case /* GiftOpen */0 :
        return "Gift Open";
    case /* DuringPurchase */1 :
        return "During Purchase";
    case /* PostPurchaseForFriend */2 :
        return "Post Purchase For Friend";
    case /* PostPurchaseForSelf */3 :
        return "Post Purchase For Self";
    case /* SignupPage */4 :
        return "Signup Page";
    
  }
}

var make = React.memo(function (props) {
      var segmentData = props.segmentData;
      var purchaseCallback = props.purchaseCallback;
      var orderNumber = props.orderNumber;
      var signupType = props.signupType;
      var state = props.state;
      var match = FormReducer.useFormReducer(undefined);
      var formDispatch = match[1];
      var formState = match[0];
      var match$1 = React.useState(function () {
            return true;
          });
      var setCanResend = match$1[1];
      var canResend = match$1[0];
      var match$2 = UserContext.useUser(undefined);
      var dispatchUserAction = match$2[1];
      var router = Router.useRouter();
      var layoutData = LayoutDataContext.useContext(undefined);
      var registerData = Belt_Option.flatMap(layoutData, (function (o) {
              return o.register;
            }));
      var registrationFlowSignupType = Segment.Registration.getSignupTypeAsString(signupType);
      var stepTitleSecurityCode = Belt_Option.mapWithDefault(registerData, "<p>Please enter the security code we sent to you via SMS.</p>", (function (c) {
              return c.stepTitleSecurityCode;
            }));
      var resendCodeText = Belt_Option.mapWithDefault(registerData, "Resend code", (function (c) {
              return c.resendCodeText;
            }));
      var resendingCodeText = Belt_Option.mapWithDefault(registerData, "Please wait", (function (c) {
              return c.resendingCodeText;
            }));
      var signUpCtaText = Belt_Option.mapWithDefault(registerData, "Sign up", (function (c) {
              return c.signUpCtaText;
            }));
      var form = ReactHookForm.useForm({
            mode: "onChange",
            defaultValues: {
              securityCode: null
            }
          }, undefined);
      var securityCodeControllerOptions = {
        name: "securityCode",
        control: form.control,
        rules: {
          required: {
            value: true,
            message: ""
          },
          minLength: {
            value: 6,
            message: ""
          }
        },
        defaultValue: null
      };
      var match$3 = ReactHookForm$1.useController(securityCodeControllerOptions);
      var match$4 = match$3.field;
      var onChange = match$4.onChange;
      var getSecurityCode = React.useCallback((function (param) {
              Js_promise.then_((function (result) {
                      if (result.TAG === /* Ok */0) {
                        return Promise.resolve(undefined);
                      } else {
                        return Promise.resolve(Curry._1(formDispatch, /* Error */{
                                        _0: {
                                          TAG: /* SecurityCodeError */1,
                                          _0: "An error occured. Please try again later."
                                        }
                                      }));
                      }
                    }), PrezzeePublicClient.securityCode({
                        email: FormHelpers.getValue(state.email),
                        phoneNumber: FormHelpers.getValue(state.phoneNumber)
                      }));
            }), [
            state.email,
            state.phoneNumber
          ]);
      var resend = React.useCallback((function (e) {
              e.preventDefault();
              Curry._1(setCanResend, (function (param) {
                      return false;
                    }));
              Curry._1(onChange, null);
              setTimeout((function (param) {
                      Curry._1(setCanResend, (function (param) {
                              return true;
                            }));
                    }), 60000);
              Curry._1(getSecurityCode, undefined);
            }), [getSecurityCode]);
      var onSubmit = React.useCallback((function (data) {
              Curry._1(formDispatch, /* Submit */0);
              var firstName = FormHelpers.getValue(state.firstName);
              var lastName = FormHelpers.getValue(state.lastName);
              var email = FormHelpers.getValue(state.email);
              var phoneNumber = FormHelpers.getValue(state.phoneNumber);
              var currentDate = new Date().toISOString();
              Js_promise.then_((function (result) {
                      var tmp;
                      if (result.TAG === /* Ok */0) {
                        if (segmentData !== undefined) {
                          Segment.customElementInteraction(Object.assign({}, {
                                    element: "sign_up_success",
                                    signup_instance_id: segmentData.signup_instance_id,
                                    path: segmentData.path,
                                    signup_type: registrationFlowSignupType
                                  }));
                        }
                        AuthUtils.saveTokenCookie({
                              userDetails: Js_null.fromOption({
                                    uid: null,
                                    firstName: firstName,
                                    lastName: lastName,
                                    email: email,
                                    phoneNumber: phoneNumber
                                  }),
                              token: result._0.accessToken,
                              masquerade: undefined
                            });
                        Curry._1(dispatchUserAction, {
                              TAG: /* Login */0,
                              _0: {
                                firstName: firstName,
                                lastName: lastName,
                                email: email,
                                phoneNumber: phoneNumber
                              }
                            });
                        setTimeout((function (param) {
                                Js_promise.then_((function (res) {
                                        var tmp;
                                        if (res.TAG === /* Ok */0) {
                                          var c = res._0;
                                          Segment.identifyWithContext(c.uid, {
                                                user_type: "consumer",
                                                first_name: c.firstName,
                                                last_name: c.lastName,
                                                phone: c.phone,
                                                email: c.email,
                                                id: c.uid,
                                                username: c.email
                                              }, false);
                                          var signedUpSegmentData = {
                                            user_type: "consumer",
                                            created_at: currentDate,
                                            username: c.email,
                                            email: c.email,
                                            first_name: c.firstName,
                                            last_name: c.lastName,
                                            phone: c.phone,
                                            signup_type: getSignupType(signupType)
                                          };
                                          tmp = Segment.signedUp(segmentData !== undefined ? Object.assign(signedUpSegmentData, {
                                                      signup_instance_id: segmentData.signup_instance_id
                                                    }) : signedUpSegmentData);
                                        } else {
                                          tmp = undefined;
                                        }
                                        return Promise.resolve(tmp);
                                      }), PrezzeeSecureClient.getCustomerData(undefined));
                              }), 500);
                        if (signupType === /* SignupPage */4 || signupType === /* PostPurchaseForSelf */3) {
                          router.push("/wallet");
                          tmp = undefined;
                        } else if (signupType === /* PostPurchaseForFriend */2) {
                          router.push("/store");
                          tmp = undefined;
                        } else {
                          tmp = signupType === /* GiftOpen */0 ? (
                              purchaseCallback !== undefined ? Curry._1(purchaseCallback, undefined) : undefined
                            ) : Curry._1(formDispatch, /* Success */1);
                        }
                      } else {
                        var e = result._0;
                        if (segmentData !== undefined) {
                          Segment.customElementInteraction(Object.assign({}, {
                                    element: "sign_up_fail",
                                    signup_instance_id: segmentData.signup_instance_id,
                                    path: segmentData.path,
                                    signup_type: registrationFlowSignupType
                                  }));
                        }
                        switch (e.TAG | 0) {
                          case /* NetworkError */0 :
                          case /* JsonParsingError */1 :
                              tmp = Curry._1(formDispatch, /* Error */{
                                    _0: /* UnexpectedError */0
                                  });
                              break;
                          case /* ServerError */2 :
                              var serverError = e._0;
                              tmp = typeof serverError === "number" || serverError.TAG !== /* ServerValidationError */0 ? Curry._1(formDispatch, /* Error */{
                                      _0: /* UnexpectedError */0
                                    }) : Curry._1(formDispatch, /* Error */{
                                      _0: {
                                        TAG: /* LoginError */0,
                                        _0: serverError._0
                                      }
                                    });
                              break;
                          
                        }
                      }
                      return Promise.resolve(tmp);
                    }), PrezzeeSecureClient.register({
                        firstName: firstName,
                        lastName: lastName,
                        email: email,
                        phoneNumber: phoneNumber,
                        password: FormHelpers.getValue(state.password),
                        securityCode: FormHelpers.getValue(data.securityCode),
                        marketingOptIn: state.marketingOptIn,
                        orderNumber: orderNumber
                      }));
            }), [state]);
      var error = formState.error;
      var tmp;
      tmp = error !== undefined ? (
          typeof error === "number" ? JsxRuntime.jsx($$Notification.make, {
                  notificationType: /* NotificationWarning */3,
                  title: "Connection error",
                  description: "Sorry, we can't reach prezzee at the moment, please check your internet connection",
                  className: "w-full mb-4"
                }) : (
              error.TAG === /* LoginError */0 ? JsxRuntime.jsx($$Notification.make, {
                      notificationType: /* NotificationInfo */1,
                      title: "Login error",
                      description: error._0,
                      className: "w-full mb-4"
                    }) : JsxRuntime.jsx($$Notification.make, {
                      notificationType: /* NotificationInfo */1,
                      title: "Resend error",
                      description: error._0,
                      className: "w-full mb-4"
                    })
            )
        ) : null;
      return JsxRuntime.jsxs(React.Fragment, {
                  children: [
                    tmp,
                    JsxRuntime.jsxs("form", {
                          children: [
                            JsxRuntime.jsx("label", {
                                  children: JsxRuntime.jsx(RichText$PrezzeeRibbon.make, {
                                        children: stepTitleSecurityCode
                                      }),
                                  className: SignUpStepStyles.formLabel,
                                  htmlFor: "security-code"
                                }),
                            JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx(FormInputPin, {
                                          pinLength: 6,
                                          onChange: Curry.__1(onChange),
                                          value: FormHelpers.getValue(match$4.value)
                                        }),
                                    JsxRuntime.jsx("button", {
                                          children: Util.ReactStuff.s(!formState.isSubmitting && canResend ? resendCodeText : resendingCodeText),
                                          className: Cn.make([
                                                !formState.isSubmitting && canResend ? "block text-sm w-full text-right underline mt-2" : "block text-sm w-full text-right mt-2",
                                                btn
                                              ]),
                                          disabled: formState.isSubmitting || !canResend,
                                          type: "button",
                                          onClick: resend
                                        })
                                  ],
                                  className: codeContainer,
                                  id: "security-code"
                                }),
                            JsxRuntime.jsx(Button$PrezzeeRibbon.make, {
                                  children: JsxRuntime.jsx("button", {
                                        children: Util.ReactStuff.s(signUpCtaText),
                                        className: "mt-8",
                                        disabled: formState.isSubmitting || !form.formState.isValid,
                                        type: "submit"
                                      })
                                })
                          ],
                          onSubmit: Curry._2(form.handleSubmit, onSubmit, FormHelpers.onError)
                        })
                  ]
                });
    });

export {
  Styles ,
  getSignupType ,
  make ,
}
/* nestedInput Not a pure module */
